import { useMemo }         from 'react';
import { connect }         from 'react-redux';
import { Dispatch }        from "redux";
import { ActionTypes }     from 'actions/types';
import { reducerType }     from 'reducer';
import Container           from './Container';
import ButtonAndLogo       from './ButtonAndLogo';
import DropDown            from 'components/navbar/dropdown';
import useDropDownItems    from './useDropDownItems';
import useDropDownVariant  from './useDropDownVariant';
import useNavbarStyle      from './useNavbarStyle';
import { colors }          from 'utils/colors';
import handleNBClick       from './handleNvabarClick';
import logo                from 'images/yisumaticaLogo.png';
import { 
  componentsStateType, 
  manualNavStateType, 
  menusStateType, 
  sizeStateType
}                          from 'reducer/types';

import { SET_MENUS_STATE } from 'actions/menusActions';
import { makeStyles }      from 'makeStyles';


let links        = new Array(7).fill('').map((val, ind) => { return `kita${ ind + 1 }` });
let selfTeaching = new Array(4).fill('').map((val, ind) => { return ind ? `kita${ ind + 3 }` : 'kita3partiacl' });

links.unshift('linksVideo')
selfTeaching.unshift('selfTeachVideo')

const useStyles = makeStyles()(() => ({
    root: {
        position:        'fixed',
        top:             0,
        left:            0,
        width:           '100vw',
        backgroundColor: '#FFF',
        borderBottom:    '1px solid #DDD',
        transition:      'all 0.4s',
        boxShadow:       '3px 3px 3px rgba(0,0,0,0.05)'
    },
    container: {
      position:        'absolute',
      top:             0,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-evenly',
      backgroundColor: '#FFF'
    },
    selector: {
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.5
      }
    },
    big: {
      fontSize: 20,
      padding:  2
    },
    icon_container: {
      position:        'absolute',
      right:           0,
      width:           '15vw',
     // height:          100,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      cursor:          'pointer',
    },
    icon: {
      color:    colors.darkText,
      fontSize: 28
    },
    logoContainer: {
      position:       'absolute',
      right:          0,
      width:          '15vw',
    //  height:         100,
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'flex-end',
    },
    logo: {
      width:              '85%',
      height:             50,
      backgroundImage:    `url(${ logo })`,
      backgroundPosition: 'left',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    },
    groupUrl: {
      position:       'absolute',
      minWidth:       '100vw',
      height:         '100%',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      textAlign:      'center',
      fontSize:       25,
      fontWeight:     'bold'
    }
}))

type NavBarProps = {
  componentsState:      componentsStateType;
  menusState:           menusStateType;
  sizeState:            sizeStateType;
  openDropDown:         string;
  page:                 string;
  manualNavState:       manualNavStateType;
  setMenusState:        (payload: menusStateType) => void;
}

const NavBar: React.FC<NavBarProps> = ({ 
  componentsState,
  menusState,
  openDropDown,
  sizeState,
  page,
  manualNavState,
  setMenusState
}) => {

  const { classes } = useStyles();


  const bigNavBar = useMemo(() => {
    return sizeState.size[0] >= 850
  },[sizeState])


  const dropDownItems   = useDropDownItems(bigNavBar, openDropDown, links, selfTeaching)
  const dropDownVariant = useDropDownVariant(openDropDown)
  


  const { rootStyle, containerStyle, logoStyle } = useNavbarStyle(bigNavBar)

  return (
    <div 
         dir       = 'rtl'
         className = { classes.root }
         style     = { rootStyle }
    >
      <ButtonAndLogo
         componentsState = { componentsState }
         page            = { page }
         wideScreen      = { sizeState.wideScreen }
         logoStyle       = { logoStyle }
      />
      <DropDown
         variant         = { dropDownVariant }
         dropDownItems   = { dropDownItems }
         manualVal       = { manualNavState.manualVal }
         manualOn        = { manualNavState.manualOn }
         openDropDown    = { openDropDown }
         setOpenDropDown = { (val: string) => { setMenusState({ ...menusState, openDropDown: val }) }}
         handlePageClick = { handleNBClick }
      />
      <Container 
         containerStyle = { containerStyle }
         links          = { links }
         selfTeaching   = { selfTeaching }
      /> 
    </div>
  );
}


const mapStateToProps = (reducer: reducerType) => {

  return {
    componentsState: reducer.components,
    page:            reducer.page.page,
    menusState:      reducer.menus,
    openDropDown:    reducer.menus.openDropDown,
    manualNavState:  reducer.manualNav,
    sizeState:       reducer.size
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setMenusState: (payload: menusStateType) => dispatch(SET_MENUS_STATE(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);



